import { toMapLngLat, fromMapLngLat } from '../dashboard/basemapCoord';

/** 地图点击（显示坐标）→ 业务 WGS84 */
export function clickToWgs84(lngLat) {
  return fromMapLngLat(lngLat.lng, lngLat.lat) || [lngLat.lng, lngLat.lat];
}

/** 业务 WGS84 点列 → 当前底图显示坐标 */
export function wgs84CoordsToDisplay(coords = [], map = null) {
  return (coords || []).map(([lng, lat]) => toMapLngLat(lng, lat, undefined, map) || [lng, lat]);
}
